



























































import Vue from 'vue';
import { Form, Upload } from 'element-ui'
import config from '../../config/index';
import { exportFiles, formatUrl } from '../../common/util';
import { ElUploadInternalRawFile, ElUploadInternalFileDetail } from 'element-ui/types/upload'

interface BatchImportData {
  isShow: boolean,
  form: {
      multImportFile: string
  },
  rules: {
      multImportFile: any[]
  }
}


export default Vue.extend({
  name: 'BatchImport',
  props: ['multImport', 'multImportFile'],
  data(): BatchImportData {
    return {
        isShow: false,
        form: {
            multImportFile: '',
        },
        rules: {
            multImportFile: [
              { 
                  validator: (rule: any, value: string, callback: (error: Error | void) => void) => {
                      if (!value) {
                          this.$message.error('请上传论文信息导入Excel模版');
                          callback(new Error(''));
                      } else {
                          callback();
                      }
                  }, 
                  trigger: 'change'
              }
            ]
        }
    };
  },
  watch: {
      multImport(val) {
          this.isShow = val;
      }
  },
  computed: {
      uploadUrl() {
          return `${config.api}/api/HDCheck/UploadPaperExcel`;
      }
  },
  methods: {
      downloadTemplate() {
          exportFiles(`/论文信息导入模板.xlsx`, location.origin + config.api);
      },
      handleClose() {
          this.$emit('update:multImport', false);
      },
      beforeUpload(file: ElUploadInternalRawFile) {
          if (/\.((csv)|(xls)|(xlsx))$/i.test(file.name)) {
              return true;
          }
          this.$alert(' 只支持excel文件！', '提示');
          return false;
      },
      handleSuccess(res: any) {
          if(res === 'InvalidType') {
              this.$message.error('文件类型不符合要求，请重新上传');
          } else if(res === 'FileIsNull') {
              this.$message.error('文件为空，请重新上传');
          } else if(res === 'ImportFail') {
              this.$message.error('模板内容有误，请按填表说明填写');
          } else {
              this.$message({
                  message: '上传成功',
                  type: 'success'
              });
              this.updateStorage();
              this.$emit('update:multImportFile', res);
          }
      },
      updateStorage() {
          let uploadSet = localStorage.getItem('uploadSet');
          if(uploadSet) {
              let temp = JSON.parse(uploadSet);
              delete temp.degreeDate;
              localStorage.setItem('uploadSet',JSON.stringify(temp));
          }
      },
      handlePreview() {

      },
      handleRemove() {
          this.$emit('update:multImportFile', '');
      },
      handleExceed() {
          this.$alert('请清除已上传文件后重新上传！', '提示');
      },
      handleConfirm() {
          if(this.multImportFile) {
              this.$emit('update:multImport', false);
          } else {
              this.$message.error('请上传论文信息导入Excel模版');
          }
          // (this.$refs.multImportForm as Form).validate((valid) => {
          //     if (valid) {
          //         this.$emit('update:multImport', false);
          //     } else {
          //         return false;
          //     }
          // });
      }
  },
  mounted() {
    
  }
});
